import { render, staticRenderFns } from "./BrIndexItem.vue?vue&type=template&id=3dde15dd&"
import script from "./BrIndexItem.vue?vue&type=script&lang=js&"
export * from "./BrIndexItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports